import { ToneMapping } from './rendererTypes';

export type MultiViewRendererConfig = { toneMapping: ToneMapping; toneMappingExposure: number };

const ConfigDefault: MultiViewRendererConfig = {
  toneMapping: ToneMapping.NEUTRAL,
  toneMappingExposure: 0,
};

/**
 * Create scene viewer config.
 * @param config - Configuration options.
 */
export const create = (config?: Partial<MultiViewRendererConfig>): MultiViewRendererConfig => {
  config ??= {};
  const all = { ...ConfigDefault, ...config };
  return all;
};
